import React from 'react';
import { defineMessages } from 'react-intl';
import Message from 'components/Message';
import { SvgSchedule } from 'components/Svgs';
import './EmptyRoster.scss';

const messages = defineMessages({
  title: {
    id: 'yield-management.empty-roster.title',
    defaultMessage: 'This class has no reservations.',
  },
  subtitle: {
    id: 'yield-management.empty-roster.subtitle',
    defaultMessage: 'Please check back later.',
  },
});

const EmptyRoster = () => (
  <div className="yield-empty-roster__container">
    <SvgSchedule className="mb+" />
    <Message as="p" message={messages.title} />
    <Message as="p" message={messages.subtitle} />
  </div>
);

export default EmptyRoster;
